import axiosInstance from '../axios';
import { rejectError } from '../helper';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    getDVRChannels({ commit }) {
      return axiosInstance.get('/api/3/dvr-channels?$expand=*')
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    getDVRChannel({ commit }, id) {
      return axiosInstance.get(`/api/3/dvr-channels/${id}?$expand=*`)
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    createDVRChannel({ dispatch }, dvrChannel) {
      return axiosInstance({
        method: 'POST',
        url: '/api/3/dvr-channels',
        data: dvrChannel,
      })
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    updateDVRChannel({ dispatch }, dvrChannel) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/3/dvr-channels/${dvrChannel.id}`,
        data: dvrChannel,
      })
        .then(result => result.data.data)
        .catch(error => rejectError(error));
    },
    // eslint-disable-next-line no-unused-vars
    removeDVRChannel({ dispatch }, id) {
      return axiosInstance({
        method: 'DELETE',
        url: `/api/3/dvr-channels/${id}`,
      })
        .then(result => result.data)
        .catch(error => rejectError(error));
    },
  },
};
